import React, { useEffect, useContext } from "react";
import { Texture } from 'pixi.js'
import { ease } from 'pixi-ease'
import { Sprite, Container, withFilters } from '@inlet/react-pixi'
import { GlowFilter } from 'pixi-filters';
import { useHistory } from "react-router-dom";

import HomeContext from '../../../context/home-context';
import { getMonsterBack } from '../../../actions/monster-actions';

import { getStudentNumberFromSession } from '../../../utils/helpers/others/SessionHelper'
import { HowlerUtils } from '../../../utils/helpers/island/SoundHelper'

const Filters = withFilters(Container, {
    glow: GlowFilter,
});

const DirtyIsland = () => {
    const history = useHistory();
    const { notiOpenClick } = useContext(HomeContext);
    let trash1Texture = Texture.from('./assets/images/components/island/particle/trash/trash1.png');
    let trash2Texture = Texture.from('./assets/images/components/island/particle/trash/trash2.png');
    let binTexture = Texture.from('./assets/images/components/island/particle/trash/bin.png');
    let arrowTexture = Texture.from('./assets/images/components/island/particle/trash/arrow_down.png');
    let textTexture = Texture.from('./assets/images/components/island/particle/trash/trash_here_sign.png');
    const [filter, setFilter] = React.useState(0);
    const trash1 = React.useRef();
    const trash2 = React.useRef();
    const trash3 = React.useRef();
    const trash4 = React.useRef();
    const trash5 = React.useRef();
    const trash6 = React.useRef();
    const arrow = React.useRef();
    const arrow2 = React.useRef();
    const arrow3 = React.useRef();
    let totalTrashDeposit = 0;

    useEffect(() => {
        loadTrashEvents();
    }, []);

    const loadTrashEvents = () => {
        if (trash1.current !== null && trash1.current !== undefined) {
            trash1.current.x = 440, trash1.current.y = 400;
            trash2.current.x = 410, trash2.current.y = 115;
            trash3.current.x = 350, trash3.current.y = 260;
            trash4.current.x = 500, trash4.current.y = 130;
            trash5.current.x = 180, trash5.current.y = 220;
            trash6.current.x = 320, trash6.current.y = 160;
            ease.add(arrow.current, { position: { x: 0, y: -40 } }, { reverse: true, repeat: true, duration: 1000 })
            ease.add(arrow2.current, { position: { x: 0, y: -30 } }, { reverse: true, repeat: true, duration: 1000 })
            ease.add(arrow3.current, { position: { x: 0, y: -30 } }, { reverse: true, repeat: true, duration: 1000 })
            trash1.current
                .on('pointerdown', onDragStart)
                .on('pointerup', onDragEnd)
                .on('pointerupoutside', onDragEnd)
                .on('pointermove', onDragMove);
            trash2.current
                .on('pointerdown', onDragStart)
                .on('pointerup', onDragEnd)
                .on('pointerupoutside', onDragEnd)
                .on('pointermove', onDragMove);
            trash3.current
                .on('pointerdown', onDragStart)
                .on('pointerup', onDragEnd)
                .on('pointerupoutside', onDragEnd)
                .on('pointermove', onDragMove);
            trash4.current
                .on('pointerdown', onDragStart)
                .on('pointerup', onDragEnd)
                .on('pointerupoutside', onDragEnd)
                .on('pointermove', onDragMove);
            trash5.current
                .on('pointerdown', onDragStart)
                .on('pointerup', onDragEnd)
                .on('pointerupoutside', onDragEnd)
                .on('pointermove', onDragMove);
            trash6.current
                .on('pointerdown', onDragStart)
                .on('pointerup', onDragEnd)
                .on('pointerupoutside', onDragEnd)
                .on('pointermove', onDragMove);
        }
    }

    function onDragStart(event) {
        this.data = event.data;
        this.alpha = 0.5;
        this.dragging = true;
        this.orgX = this.x;
        this.orgY = this.y;
    }

    function onDragEnd() {
        this.alpha = 1;
        this.dragging = false;
        // set the interaction data to null       
        if (this.x >= 750 && this.x < 850
            && this.y >= 100 && this.y < 150) {
            this.visible = false;
            HowlerUtils.playSound('trash');
            //console.log("wasted!");
            setFilter(0);

            if (this.orgX === 500) {
                arrow3.current.visible = false;
            }
            if (this.orgX === 440) {
                arrow2.current.visible = false;
            }

            if (++totalTrashDeposit > 5) {
                const cleanTrashes = async () => {
                    let response = await getMonsterBack(getStudentNumberFromSession());
                    if (response > 200 || response.status === "Failed") {
                        return history.push("/SessionTimeOut")
                    }

                    if (response.status === "Success") {

                        notiOpenClick();
                    }
                    else {
                        alert("Something went wrong!");
                    }
                }

                cleanTrashes();
            }
        }
        else {
            this.x = this.orgX;
            this.y = this.orgY;
        }
        this.data = null;
    }

    function onDragMove() {
        if (this.dragging) {
            const newPosition = this.data.getLocalPosition(this.parent);
            this.x = newPosition.x;
            this.y = newPosition.y;
            if (this.x >= 750 && this.x < 850
                && this.y >= 100 && this.y < 150) {
                setFilter(4);
            }
            else {
                setFilter(0);
            }
        }
    }

    return (
        <>
            <Filters scale={1} glow={{ distance: 100, outerStrength: filter, innerStrength: filter / 4, quality: 0, color: '0xf5f5f5' }}>
                <Sprite texture={binTexture} x={790} y={130} scale={{ x: 0.2, y: 0.2 }} />
            </Filters>
            <Container x={800} y={70}>
                <Sprite ref={arrow} texture={arrowTexture} scale={{ x: 0.4, y: 0.4 }} />
                <Sprite texture={textTexture} scale={{ x: 1, y: 1 }} />
            </Container>

            <Sprite ref={trash1} texture={trash1Texture} scale={{ x: 0.2, y: 0.2 }} interactive={true} buttonMode={true} />
            <Container x={450} y={350}>
                <Sprite ref={arrow2} texture={arrowTexture} scale={{ x: 0.3, y: 0.3 }} />
            </Container>
            <Sprite ref={trash2} texture={trash1Texture} scale={{ x: 0.2, y: 0.2 }} interactive={true} buttonMode={true} />
            <Sprite ref={trash3} texture={trash1Texture} scale={{ x: 0.2, y: 0.2 }} interactive={true} buttonMode={true} />
            <Sprite ref={trash4} texture={trash2Texture} scale={{ x: 0.16, y: 0.16 }} interactive={true} buttonMode={true} />
            <Container x={500} y={80}>
                <Sprite ref={arrow3} texture={arrowTexture} scale={{ x: 0.3, y: 0.3 }} />
            </Container>
            <Sprite ref={trash5} texture={trash2Texture} scale={{ x: 0.16, y: 0.16 }} interactive={true} buttonMode={true} />
            <Sprite ref={trash6} texture={trash2Texture} scale={{ x: 0.16, y: 0.16 }} interactive={true} buttonMode={true} />
        </>
    );
};

export { DirtyIsland as default }